module.exports = __webpack_public_path__ + "static/media/project_demo_3.328fa5f7.png";